export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            有想看的影片？欢迎告诉我们，90影院为你安排
          </p>
        </div>

        <div className="max-w-lg mx-auto bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60 text-center">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-500/15 flex items-center justify-center mb-5">
            <i className="ri-mail-send-line text-2xl text-primary-500"></i>
          </div>
          <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">影片求档与意见反馈</h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6">
            找不到想看的电影或剧集？对网站有什么建议？欢迎通过以下方式联系我们，我们会在第一时间响应你的需求，尽力满足每一位80、90后观众的观影期待。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="mailto:feedback@90cinema.com"
              className="w-full sm:w-auto px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>发送邮件
            </a>
            <span className="text-sm text-foreground-400">或添加客服 QQ：1234567890</span>
          </div>
        </div>
      </div>
    </section>
  );
}